import React from 'react';
import { FaSpinner } from 'react-icons/fa';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger';
  isLoading?: boolean;
  children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({ 
  variant = 'primary', 
  isLoading = false,
  className = '',
  disabled,
  children, 
  ...props 
}) => {
  const getVariantClasses = () => {
    switch (variant) {
      case 'primary':
        return 'bg-gradient-to-r from-game-golden to-game-accent text-gray-700 hover:from-game-accent hover:to-game-golden hover:shadow-lg hover:shadow-game-golden/20';
      case 'secondary':
        return 'bg-game-medium/30 border border-game-medium/50 text-gray-300 hover:bg-game-medium/50 hover:text-white hover:border-game-light/50';
      case 'danger':
        return 'bg-gradient-to-r from-game-orange/80 to-game-red/80 border border-game-orange/50 text-white hover:from-game-orange hover:to-game-red hover:border-game-orange hover:shadow-lg hover:shadow-game-orange/20';
      default:
        return 'bg-gradient-to-r from-game-golden to-game-accent text-gray-700 hover:from-game-accent hover:to-game-golden hover:shadow-lg hover:shadow-game-golden/20';
    }
  };

  const baseClasses = 'flex items-center justify-center gap-2 px-4 py-2 font-semibold rounded-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:shadow-none';
  const variantClasses = getVariantClasses();
  const finalClassName = `${baseClasses} ${variantClasses} ${className}`.trim();

  return (
    <button 
      className={finalClassName}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading ? (
        <>
          <FaSpinner className="text-sm animate-spin" />
          <span className="sr-only">Loading...</span>
        </>
      ) : (
        children
      )}
    </button>
  );
};